import types from 'constants/actionTypes';

export const selectTemplateInCart = templateId => ({
  type: types.SELECT_TEMPLATE_IN_CART,
  payload: templateId,
});

export const unselectTemplateInCart = templateId => ({
  type: types.UNSELECT_TEMPLATE_IN_CART,
  payload: templateId,
});
